import { getPath } from '@/router/common'
const baseUrl = {
  title: '分拨运单',
  path: 'ShortHauls'
}

export default [
  {
    path: getPath('ShortHaulConnection', baseUrl),
    name: 'ShortHauls_ShortHaulConnection',
    component: () => import(/* webpackChunkName: "ShortHauls_ShortHaulConnection" */ '@/views/shortHauls/shortHaulConnection/index.vue'),
    meta: {
      title: '分拨运单'
    }
  },
  {
    path: getPath('ShortHaulScan_86308', baseUrl),
    name: 'ShortHauls_ShortHaulScan_86308',
    component: () => import(/* webpackChunkName: "ShortHauls_ShortHaulScan_86308" */ '@/views/shortHauls/shortHaulScan_86308/index.vue'),
    meta: {
      title: '短驳出库记录'
    }
  },
  {
    path: getPath('NewShortLighter', baseUrl),
    name: 'ShortHauls_NewShortLighter',
    component: () => import(/* webpackChunkName: "ShortHauls_NewShortLighter" */ '@/views/shortHauls/newShortLighter/index.vue'),
    meta: {
      title: '新增分拨|短途接驳-新增'
    }
  },
  {
    path: getPath('ShorHaulModify', baseUrl),
    name: 'ShortHauls_ShorHaulModify',
    component: () => import(/* webpackChunkName: "ShortHauls_ShorHaulModify" */ '@/views/shortHauls/shorHaulModify/index.vue'),
    meta: {
      title: '分拨明细|短驳明细'
    }
  },
  {
    path: getPath('ShorHaulsGetDataFromStock', baseUrl),
    name: 'ShortHauls_ShorHaulsGetDataFromStock',
    component: () => import(/* webpackChunkName: "ShortHauls_ShorHaulsGetDataFromStock" */ '@/views/shortHauls/shorHaulsGetDataFromStock/index.vue'),
    meta: {
      title: '尚有库存'
    }
  },
  {
    path: getPath('ShorHaulsUPD_bcqd', baseUrl),
    name: 'ShortHauls_ShorHaulsUPD_bcqd',
    component: () => import(/* webpackChunkName: "ShortHauls_ShorHaulsUPD_bcqd" */ '@/views/shortHauls/shorHaulsUPD_bcqd/index.vue'),
    meta: {
      title: '本车清单'
    }
  },
  {
    path: getPath('ShorHaulsUPD_dbf', baseUrl),
    name: 'ShortHauls_ShorHaulsUPD_dbf',
    component: () => import(/* webpackChunkName: "ShortHauls_ShorHaulsUPD_dbf" */ '@/views/shortHauls/shorHaulsUPD_dbf/index.vue'),
    meta: {
      title: '短驳信息'
    }
  },
  
]
